import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/catalyst/fleet-coach/bulk-upload", payload);
  },
};
